var MainFieldsMessageRMQ = {
  MTP: { name: "MTP" },
  RaceStatus: { name: "RaceStatus" },
  OffTime: { name: "OffTime" },
  PostTime: { name: "PostTime" },
};
export default MainFieldsMessageRMQ;
